<template>
  <div>
    By closing this window you agree to our use of cookies
    <span class="underline cursor-pointer" @click="handleClick"
      >Find out more</span
    >
  </div>
</template>

<script>
import { acceptCookies } from "@utils/cookieConsent";

export default {
  name: "BlockCookies",

  beforeDestroy() {
    acceptCookies();
  },

  methods: {
    handleClick() {
      this.$store.commit("removeAllModals");
      this.$router.push({ name: "Terms" });
    }
  }
};
</script>
